import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';

interface IConfirmDeleteDialogProps {
  title: string;
  open: boolean;
  info: any;
  id: string;
  onClose: () => void;
  onDelete: (itemId: string) => void;
}

export const ConfirmDeleteDialog = (props: IConfirmDeleteDialogProps) => {
  return ( 
    <Dialog onClose={() => {props.onClose()}} aria-labelledby="delete-dialog-title" open={props.open}>
      <DialogTitle id="delete-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          Are you sure you want to delete? 
          {props.info}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={() => {props.onClose()}} 
          color="primary"
          variant="outlined"
        >
          Cancel
        </Button>
        <Button 
          onClick={() => {props.onDelete(props.id)}} 
          color="primary"             
          variant="contained"
          startIcon={<DeleteOutlinedIcon fontSize="small" />}
          autoFocus
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
